import api from '@/client/core/api'
import {
  GetInstagramInstantwinPrizesData,
  GetInstagramInstantwinPrizesParams,
  GetInstagramInstantwinPrizesResponse
} from '@/typings/api/instagram_instantwin_prizes.schema'

/**
 * Instagram インスタントウィン応募グループ一覧を取得
 *
 * @param params - 検索パラメータ (campaignId, sortBy, pagingNo, limitCount, forCsv)
 * @returns 応募グループ一覧とページング情報
 * @throws データ取得に失敗した場合にエラーをthrow
 *
 * @example
 * const prizes = await getInstagramInstantwinPrizes({
 *   campaignId: 123,
 *   sortBy: '-applicantCount',
 *   pagingNo: 1,
 *   limitCount: 25
 * })
 */
export async function getInstagramInstantwinPrizes(
  params: GetInstagramInstantwinPrizesParams
): Promise<GetInstagramInstantwinPrizesResponse> {
  const result = await api.get<GetInstagramInstantwinPrizesData>('/instagram_instantwin_prizes', { params })

  return result.data
}
